<template>
    <div class="nav-menu-wrapper">
        <template v-for="item in menuData">
            <el-submenu v-if="item.children" :index="item.id" :key="item.id">
                <template slot="title">
                    <span>{{item.title}}</span>
                </template>
                <nav-menu :menuData="item.children"></nav-menu>
            </el-submenu>
            <el-menu-item :key="`item-${item.id}`" :index="item.id" v-else class="title">
                <div @click="goto(item)">{{item.title}}</div>
            </el-menu-item>
        </template>
    </div>
</template>

<script>
import { gotoListPage } from '@/uitls/page';

export default {
    name: 'NavMenu',
    props: {
        menuData: {
            type: Array,
            required: true
        }
    },
    methods: {
        goto(data) {
            gotoListPage(data, this.$router);
            this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': data.title })
        }
    }
}
</script>

<style lang="scss">
.el-menu-demo {
    .nav-menu-wrapper {
        display: flex;

        .el-submenu__icon-arrow {
            right: 5px;
            margin-top: -4px;
            color: #333;
            font-weight: bold;
        }

        .el-dropdown-menu__item,
        .el-menu-item,
        .el-submenu__title {
            font-size: 16px;
            color: #333;

            @include pc-style-note {
                font-size: 14px;
            }
        }
        .title:first-child{
            padding-left: 0;
        }

        .el-menu-item:focus,
        .el-menu-item:hover,
        .el-submenu__title:focus,
        .el-submenu__title:hover {
            background-color: transparent;
            color: #0076CE;
        }
    }
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
    font-size: 16px;
    color: #333;

    @include pc-style-note {
        font-size: 14px;
    }
    &:hover {
        color: #0076CE;

        div {
            color: #0076CE;
        }
    }
}
</style>